/* RESPONSIBLE TEAM: team-inbox-experience */

enum Theme {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

export default Theme;
